import service from '@/utils/request'

// 列表
export function actPartyBuildingList(data) {
    return service({
        url: '/service/admin/actPartyBuildingList',
        method: 'get',
        params: data
    })
}

// 详情
export function actPartyBuildingElem(data) {
    return service({
        url: '/service/admin/actPartyBuildingElem',
        method: 'get',
        params: data
    })
}

// 新增
export function actPartyBuildingAdd(data) {
    return service({
        url: '/service/admin/actPartyBuildingAdd',
        method: 'post',
        data
    })
}

// 编辑
export function actPartyBuildingEdit(data) {
    return service({
        url: '/service/admin/actPartyBuildingEdit',
        method: 'post',
        data
    })
}

// 删除
export function actPartyBuildingDelete(data) {
    return service({
        url: '/service/admin/actPartyBuildingDelete',
        method: 'post',
        data
    })
}
